import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import tableAppContentCatalog from './tableAppContentCatalog';
import tableSportRoomContentCatalog from './tableSportRoomContentCatalog';
import viewAppCategories from './viewRelatedAppCategories';

export default {
  attributeName: 'appContent',
  // canOpen: true,
  canEdit: true,
  customEditUrl:'content/areaId',
  editURL: routes.APP_CONTENT_EDIT,
  emptyMessage: "You don't have content with this VT.",
  fields: [
    {
      attributeName: 'visibility',
      label: 'Visibility',
      type: FormInputTypes.TEXT_INPUT,
      helpText: 'Visibility of the video in the panel where its listed.',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
      canEdit: true,
      canCreate: false,
      canOrder:false,
      width: '10rem',
    },
    {
      attributeName: 'config',
      label: 'Config',
      type: FormInputTypes.TEXT_INPUT,
      helpText: 'Config to which it belongs.',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
      canEdit: true,
      canCreate: false,
      canFilter: true,
      width: '10rem',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT,
      helpText: 'Title of the video.',
      default: '',
      canEdit: false,
      canOrder: true,
      canCreate: false,
      canFilter: true,
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation',
      type: FormInputTypes.TIMESTAMP,
      mode:"milisecond",
      canOrder: true,
      helpText: 'Activation of content.',
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration',
      type: FormInputTypes.TIMESTAMP,
      canOrder: true,
      mode:"milisecond",
      canFilter:false,
      helpText: 'Expiration of the content.',
    },
  ],
};
